import React, { useMemo } from 'react';
import Table from '../../../componentsV2/Table/Table';
import { compareObjectsForAudit, dateTimeFormatter } from '../../../utils/utils';
import type { 
  AuditResult, 
  MetadataObject 
} from '../../../types/audit.types';

// Local types
interface AuditComparisonTableProps {
  obj1: MetadataObject;
  obj2: MetadataObject;
  title?: string;
}
const AuditComparisonTable: React.FC<AuditComparisonTableProps> = ({ 
  obj1, 
  obj2, 
}) => {
  // Helper function to format value based on datatype
  const formatValue = (value: string, datatype?: string): string => {
    if (!value || value === 'Empty') {
      return value || '';
    }
    
    // If it's a DATE datatype and the value doesn't look already formatted, apply date formatting
    if (datatype === 'DATE' && value && !value.includes('/')) {
      return dateTimeFormatter(value);
    }
    
    return value;
  };

  // Generate audit results and filter only modified values
  const auditResults = useMemo((): AuditResult[] => {
    const results = compareObjectsForAudit(obj1, obj2);
    // Filter to show only changed/modified values
    const modifiedResults = results.filter((result: AuditResult) => result.status === 'changed');
    console.log('AuditComparisonTable: Generated audit results:', results.length, 'total,', modifiedResults.length, 'modified');
    return modifiedResults;
  }, [obj1, obj2]);

  // Define columns for Table.tsx component
  const columns = [
    {
      header: 'Field Name',
      accessor: 'prompt',
      sortable: true,
      cell: (row: AuditResult) => (
        <span style={{ fontWeight: 600 }}>{row.prompt}</span>
      )
    },
    {
      header: 'Previous Value',
      accessor: 'obj1_display_value',
      sortable: true,
      cell: (row: AuditResult) => (
        <span>
          {formatValue(row.obj1_display_value, row.datatype)}
        </span>
      )
    },
    {
      header: 'New Value',
      accessor: 'obj2_display_value',
      sortable: true,
      cell: (row: AuditResult) => (
        <span>
          {formatValue(row.obj2_display_value, row.datatype)}
        </span>
      )
    },
  
 
  ];

  return (
    <Table 
      data={auditResults} 
      columns={columns}
      isExpandable={false}
    />
  );
};

export default AuditComparisonTable;
